import PropTypes from "prop-types";
import React from "react";
import { Select } from "cxa-components";
import { FormattedMessage, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const ethnicityData = {
  1: "African",
  2: "Asian",
  3: "Caucasian",
  4: "Latino-Hispanic",
  5: "South-Asian",
  6: "Other",
};

const EthnicitySelect = injectIntl(
  ({ ethnicity, handleChangeEthnicity, intl }) =>
    <p>
      <label htmlFor="ethnicityId">
        <FormattedMessage {...messages.selectYourEthnicityDescription} />
      </label>{" "}
      <Select
        name="ethnicityId"
        id="ethnicityId"
        value={ethnicity}
        onChange={handleChangeEthnicity}
      >
        {Object.keys(ethnicityData).map(key =>
          <option key={key} value={key}>
            {intl.formatMessage({
              id: ethnicityData[key],
              defaultMessage: ethnicityData[key],
            })}
          </option>
        )}
      </Select>
    </p>
);

EthnicitySelect.propTypes = {
  ethnicity: PropTypes.node,
  handleChangeEthnicity: PropTypes.func,
};

export default EthnicitySelect;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/ethnicitySelect.jsx